import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=a98884e0&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=a98884e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98884e0",
  null
  
)

export default component.exports